/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useMemo, useRef, useState } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import tracker from 'lib/tracker';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import { map } from 'lodash';
import Up from 'assets/Up.png';
import Down from 'assets/Down.png';
import Down2 from 'assets/Down2.png';
import Down3 from 'assets/Down3.png';
import Up2 from 'assets/Up2.png';
import Up3 from 'assets/Up3.png';
import featured from 'assets/Featured.png';
import { useMediaQuery } from 'react-responsive';
import useIsMobile from 'lib/useIsMobile';
import Link from 'found/lib/Link';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tip1 from 'assets/Tip1.png';
import VectorOrange from 'assets/VectorOrange.png';
import DashboardWhatisThisDialogue from './WhatDialogue';
import DashboardAppOpen from './AppOpen';
import className from './cardlist.scss';

const styles = {
  listStyle: {
    display: 'inline-block',
    marginBottom: '5%',
    marginRight: '3%',
    width: '45%',
  },
  listStyleMobile: {
    width: '100%',
    display: 'inline-block',
    marginBottom: '0%',
    marginRight: '3%',
    marginTop: '0%',
    paddingRight: '4%',
    paddingLeft: '4%',
  },
  listStyleShowMore: {
    width: '100%',
    display: 'inline-block',
    marginBottom: '5%',
    float: 'left',
    height: '100VH',
  },
  listHeader: {
    color: '#000000',
    fontWeight: '700',
    fontSize: '1.5vw',
    backgroundColor: '#FFFFFF',
    marginTop: 25,
    zIndex: 2,
    top: 20,
    fontFamily: 'NewOrderBold',
  },
  listHeaderMobile: {
    color: '#000000',
    fontWeight: '700',
    fontSize: '20px',
    backgroundColor: '#FFFFFF',
    marginTop: 25,
    zIndex: 2,
    top: 20,
    fontFamily: 'NewOrderBold',
  },
  marginHeader: {
    padding: '20px',
    zIndex: 1,
    background: '#fff',
    position: 'sticky',
    top: 0,
  },
  listIcon: {
    position: 'absolute',
    width: '119px',
    height: '94px',
    top: '-45px',
    left: '65%',
  },
  score: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: '32px',
    textAlign: 'center',
    position: 'relative',
    top: '27%',
    fontFamily: 'NewOrderBold',
  },
  scoreMobile: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: '32px',
    textAlign: 'center',
    position: 'relative',
    top: '27%',
    fontFamily: 'NewOrderBold',
  },
  listItem: {
    fontFamily: 'NiveauGroteskRegular',
  },
  listItemMobile: {
    paddingTop: '0px',
    paddingBottom: '0px',
    fontFamily: 'NiveauGroteskRegular',
  },
  activityCompletion: {
    border: '1px solid #ACACAC',
    background: '#0076BB',
    height: '80px',
    borderBottom: 'none',
    borderTop: 'none',
    fontSize: '22px',
    fontWeight: '400',
    color: 'white',
  },
  scoreIcon: {
    width: '34px',
    height: '34px',
  },
  scoreIconMobile: {
    width: '30px',
    height: '30px',
  },
  listItemBottom: {},
  listItemBottomMobile: {},
  listItemBottomShowMore: {
    border: '1px solid #ACACAC',
    borderTop: 0,
    borderRadius: '0px 0px 15px 15px',
  },
  whatIsThis: {
    border: '1px solid #0076BB',
    borderRadius: '10px',
    color: '#0076BB',
    width: '35%',
    height: '60px',
    fontWeight: '700',
    fontSize: '15px',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'inline-block',
    float: 'left',
    marginRight: '5%',
    boxShadow: '30px 0px #e2eff6 inset',
    fontFamily: 'jost',
  },
  whatIsThisMobile: {
    border: '1px solid #0076BB',
    borderRadius: '10px',
    color: '#0076BB',
    width: '40%',
    height: '40px',
    fontWeight: '700',
    fontSize: '14px',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'inline-block',
    float: 'left',
    marginRight: '3%',
    boxShadow: '30px 0px #e2eff6 inset',
    fontFamily: 'jost',
  },
  completeActivities: {
    border: '1px solid #0076BB',
    borderRadius: '10px',
    background: '#0076BB',
    color: 'white',
    width: '60%',
    height: '60px',
    fontWeight: '700',
    fontSize: '18px',
    // textAlign: 'center',
    cursor: 'pointer',
    // display: 'inline-block',
    float: 'left',
    fontFamily: 'NiveauGroteskRegular',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  completeActivitiesMobile: {
    border: '1px solid #0076BB',
    borderRadius: '10px',
    background: '#0076BB',
    color: 'white',
    width: '56%',
    height: '40px',
    fontWeight: '700',
    fontSize: '18px',
    // textAlign: 'center',
    // cursor: 'pointer',
    // display: 'inline-block',
    float: 'left',
    fontFamily: 'NiveauGroteskRegular',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  bulbIconStyle: {
    height: '25px',
    width: '25px',
    display: 'inline-block',
    marginRight: '2%',
  },
  arrowIcon: {
    width: '18px',
    height: '22px',
    display: 'inline-block',
    marginLeft: 10,
  },
  arrowIconMobile: {
    width: '14px',
    height: '18px',
    display: 'inline-block',
    marginLeft: 10,
  },
  orangeCurve: {
    position: 'absolute',
    top: '29%',
    left: '80%',
    transform: 'translate(-50%, -50%)',
    height: '70px',
    width: '120px',
    borderRadius: '150px 150px 0 0',
    backgroundColor: '#ff781f',
    textAlign: 'center',
  },
  orangeCurveMobile: {
    position: 'absolute',
    top: '43%',
    left: '78%',
    transform: 'translate(-50%, -50%)',
    height: '55px',
    width: '95px',
    borderRadius: '150px 150px 0 0',
    backgroundColor: '#ff781f',
    textAlign: 'center',
  },
  moreStyle: {
    cursor: 'pointer',
    color: '#0076BB',
    border: '2px solid #0076BB',
    borderRadius: '30px',
    width: '75px',
    display: 'inline-block',
    textAlign: 'center',
    fontFamily: 'jost',
    fontSize: '14px',
  },
  pofileArrow: {
    display: 'inline-block',
    width: '0px',
    height: '0px',
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    borderLeft: '8px solid #0076BB',
    position: 'relative',
    top: '4px',
    left: '5px',
  },
};

const getIcon = (val, track) => {
  if (track === 'FEATURED') {
    return featured;
  }
  if (val === -1) {
    return Down;
  }
  if (val === 1) {
    return Up;
  }
  if (val === 2) {
    return Up2;
  }
  if (val === 3) {
    return Up3;
  }
  if (val === -2) {
    return Down2;
  }
  if (val === -3) {
    return Down3;
  }
  return Down;
};

const CredList = ({
  values,
  setShowmore,
  showMore,
  pageNo,
  fetchNewRecords,
  trackerData,
  noOfActivities,
  showAll,
}) => {
  const [open, setOpen] = useState(false);
  const [openApp, setOpenApp] = useState(false);
  const mobile = useIsMobile();
  const tablet = useMediaQuery({ maxWidth: 960 });
  const listInnerRef = useRef();
  const [hasMore, setHasMore] = useState(true);

  const hideDialogue = () => {
    setOpen(false);
  };
  const hideAppDialogue = () => {
    setOpenApp(false);
  };

  const onScroll = () => {
    if (listInnerRef.current && showMore && hasMore) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        // fetchNewRecords(pageNo + 1);

        fetchNewRecords(pageNo + 1, setHasMore);
      }
    }
  };

  const lStyle = useMemo(() => {
    if (mobile || tablet) {
      return styles.listStyleMobile;
    }
    return showMore ? styles.listStyleShowMore : styles.listStyle;
  }, [mobile, showMore, tablet]);

  const renderList = () => {
    return (
      <List
        aria-labelledby='nested-list-subheader'
        subheader={
          !showAll && (
            <ListSubheader
              style={
                mobile || tablet ? styles.listHeaderMobile : styles.listHeader
              }
              component='div'
              id='nested-list-subheader'
            >
              Ripple Street Cred
              <div
                style={
                  mobile || tablet
                    ? styles.orangeCurveMobile
                    : styles.orangeCurve
                }
              >
                <span
                  style={mobile || tablet ? styles.scoreMobile : styles.score}
                >
                  {values?.metricInfo?.score
                    ? Number(values?.metricInfo?.score).toFixed(1)
                    : 0}
                </span>
              </div>
            </ListSubheader>
          )
        }
        style={{
          ...lStyle,
          border: showAll ? '' : '1px solid #ACACAC',
          borderRadius: showAll ? 0 : 15,
        }}
      >
        {!showAll && (
          <ListItem
            style={{
              paddingTop: '0px',
            }}
          >
            <ListItemText style={{ marginTop: '0px' }}>
              <div
                onClick={() => {
                  tracker.trackGoogleAnalyticsEvent(
                    'ABOUT_CRED',
                    'ABOUT_CRED',
                    trackerData,
                  );
                  setOpen(true);
                }}
                style={
                  mobile || tablet ? styles.whatIsThisMobile : styles.whatIsThis
                }
              >
                <InfoOutlinedIcon
                  style={{
                    position: 'relative',
                    top: mobile || tablet ? '22%' : '29%',
                  }}
                />
                <span
                  style={{
                    position: 'relative',
                    top: mobile || tablet ? '25%' : '31%',
                    fontSize: 14,
                  }}
                >
                  What is this?
                </span>
              </div>
              <div
                style={
                  mobile || tablet
                    ? styles.completeActivitiesMobile
                    : styles.completeActivities
                }
              >
                {values?.history?.length > 0 && (
                  <div
                    onClick={() => {
                      tracker.trackGoogleAnalyticsEvent(
                        'COMPLETE_ACTIVITIES',
                        'COMPLETE_ACTIVITIES',
                        trackerData,
                      );
                      setOpenApp(true);
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <span
                        style={{
                          display: 'block',
                          fontSize: 14,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {noOfActivities && noOfActivities.length > 0 ? `Complete${' '} ` : `All activities${' '}`}
                        <span
                          style={{
                            color: '#F48120',
                            fontWeight: 'bold',
                            fontSize: 14,
                          }}
                        >
                          {noOfActivities && noOfActivities.length > 0 ? noOfActivities.length : `are${' '}`}
                        </span>{' '}
                        {noOfActivities && noOfActivities.length > 0 ? 'Activities' : 'completed' }
                      </span>
                      <img
                        style={
                          mobile || tablet
                            ? styles.arrowIconMobile
                            : styles.arrowIcon
                        }
                        src={VectorOrange}
                        alt='orange'
                      />
                    </div>
                  </div>
                )}
                {(values?.history?.length <= 0 || !values?.history) && (
                  <Link
                    to='/events'
                    onClick={() => {
                      tracker.trackGoogleAnalyticsEvent(
                        'DISCOVER_NEW_EVENTS',
                        'DISCOVER_NEW_EVENTS',
                        trackerData,
                      );
                    }}
                  >
                    <span
                      style={{
                        display: 'block',
                        whiteSpace: 'nowrap',
                        fontSize: 14,
                      }}
                    >
                      Discover New Events{' '}
                      <img
                        style={
                          mobile || tablet
                            ? styles.arrowIconMobile
                            : styles.arrowIcon
                        }
                        src={VectorOrange}
                        alt='orange'
                      />
                    </span>
                  </Link>
                )}
              </div>
            </ListItemText>
          </ListItem>
        )}

        {values?.history?.length > 0 && (
          <>
            {map(
              showAll ? values?.history : values?.history?.slice(0, 4),
              lt => (
                <ListItem
                  button
                  style={
                    mobile || tablet ? styles.listItemMobile : styles.listItem
                  }
                >
                  <ListItemText
                    style={{ marginTop: '0px', marginBottom: '0px' }}
                  >
                    <div
                      style={{
                        background: lt?.weight <= 0 ? '#FFECEC' : '#E2EFF6',
                        borderRadius: '5px',
                        padding: '8px 7px 8px 7px',
                        cursor: 'default',
                        display: 'flex',
                        color: 'black',
                        marginBottom: mobile || tablet ? 20 : 0,
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Image
                          alt='up'
                          showLoading={false}
                          src={getIcon(lt.weight, lt.tracker)}
                          style={
                            mobile || tablet
                              ? styles.scoreIconMobile
                              : styles.scoreIcon
                          }
                        />
                      </div>
                      <span
                        style={{
                          marginLeft: mobile || tablet ? '3%' : '2%',
                          width: mobile || tablet ? '60%' : '60%',
                          display: 'inline-block',
                          fontSize: mobile || tablet ? '14px' : '15px',
                        }}
                      >
                        {lt.action}
                      </span>
                      <span
                        style={{
                          position: 'absolute',
                          left: mobile || tablet ? '73%' : '73%',
                        }}
                      >
                        {lt.date}
                      </span>
                    </div>
                  </ListItemText>
                </ListItem>
              ),
            )}
          </>
        )}
        {values?.history?.length <= 0 && (
          <>
            <ListItem
              button
              style={
                mobile || tablet
                  ? styles.listItemBottomMobile
                  : styles.listItemBottom
              }
            >
              <ListItemText
                style={{
                  padding: '2%',
                  background: '#F5F5F5',
                  border: '1px solid #ACACAC',
                  borderRadius: '5px',
                }}
              >
                <div
                  style={{
                    fontStyle: 'normal',
                    fontWeight: '400',
                    fontSize: '14px',
                    display: 'flex',
                    marginBottom: '1%',
                    alignItems: 'center',
                  }}
                >
                  {' '}
                  <img
                    src={Tip1}
                    alt='light'
                    style={styles.bulbIconStyle}
                  />{' '}
                  <span style={{ display: 'inline-block' }}>
                    <b style={{ color: 'black' }}>
                      Every application you complete increases your Cred rating.
                    </b>
                  </span>
                </div>
                <br />
                <div
                  style={{
                    fontStyle: 'normal',
                    fontWeight: '400',
                    fontSize: '14px',
                    display: 'flex',
                    marginBottom: '1%',
                    alignItems: 'center',
                  }}
                >
                  {' '}
                  <img
                    src={Tip1}
                    alt='light'
                    style={styles.bulbIconStyle}
                  />{' '}
                  <span style={{ display: 'inline-block' }}>
                    <b style={{ color: 'black' }}>
                      Every activity you complete increases your Cred rating.
                    </b>
                  </span>
                </div>
                <br />
                <div
                  style={{
                    fontStyle: 'normal',
                    fontWeight: '400',
                    fontSize: '14px',
                    display: 'flex',
                    marginBottom: '1%',
                    alignItems: 'center',
                  }}
                >
                  {' '}
                  <img
                    src={Tip1}
                    alt='light'
                    style={styles.bulbIconStyle}
                  />{' '}
                  <span style={{ display: 'inline-block' }}>
                    <b style={{ color: 'black' }}>
                      Every activity you do not complete decreases your Cred
                      rating.
                    </b>
                  </span>
                </div>
                <br />
              </ListItemText>
            </ListItem>
          </>
        )}
        {values?.history?.length > 0 && !showMore ? (
          <ListItem
            style={
              mobile || tablet
                ? styles.listItemBottomMobile
                : styles.listItemBottom
            }
          >
            <ListItemText
              style={{
                color: '#0076BB',
                fontSize: '18px',
                fontStyle: 'italic',
                fontWeight: '400',
                textAlign: 'right',
              }}
            >
              <div>
                <span
                  style={styles.moreStyle}
                  onClick={() => {
                    tracker.trackGoogleAnalyticsEvent(
                      'CRED_HISTORY',
                      'CRED_HISTORY',
                      trackerData,
                    );
                    setShowmore(true);
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    });
                  }}
                >
                  More
                  <span style={styles.pofileArrow} />
                </span>
              </div>
            </ListItemText>
          </ListItem>
        ) : (
          showMore && (
            <ListItem style={styles.listItemBottomShowMore}>
              <ListItemText
                style={{
                  color: '#0076BB',
                  fontSize: '18px',
                  fontStyle: 'italic',
                  fontWeight: '400',
                  textAlign: 'right',
                }}
              />
            </ListItem>
          )
        )}
      </List>
    );
  };
  return (
    <>
      <DashboardWhatisThisDialogue onCancel={hideDialogue} open={open} />
      <DashboardAppOpen onCancel={hideAppDialogue} open={openApp} />
      {showMore ? (
        <div
          style={{
            display: 'inline-block',
            width: mobile || tablet ? '96%' : '50%',
            margin: mobile || tablet ? '0' : '25px auto',
            border: '1px solid #ACACAC',
            borderRadius: '20px 20px 40px 20px',
            overflow: 'hidden',
            alignSelf: 'center',
          }}
        >
          <ListSubheader
            style={
              mobile || tablet ? styles.listHeaderMobile : styles.listHeader
            }
            component='div'
            id='nested-list-subheader'
          >
            Ripple Street Cred
            <div
              style={
                mobile || tablet ? styles.orangeCurveMobile : styles.orangeCurve
              }
            >
              <span
                style={mobile || tablet ? styles.scoreMobile : styles.score}
              >
                {values?.metricInfo?.score
                  ? Number(values?.metricInfo?.score).toFixed(1)
                  : 0}
              </span>
            </div>
          </ListSubheader>
          <ListItem>
            <ListItemText style={{ marginTop: '0px' }}>
              <div
                onClick={() => {
                  tracker.trackGoogleAnalyticsEvent(
                    'ABOUT_CRED',
                    'ABOUT_CRED',
                    trackerData,
                  );
                  setOpen(true);
                }}
                style={
                  mobile || tablet ? styles.whatIsThisMobile : styles.whatIsThis
                }
              >
                <InfoOutlinedIcon
                  style={{
                    position: 'relative',
                    top: mobile || tablet ? '22%' : '29%',
                  }}
                />
                <span
                  style={{
                    position: 'relative',
                    top: mobile || tablet ? '25%' : '31%',
                    fontSize: 14,
                  }}
                >
                  What is this?
                </span>
              </div>
              <div
                style={
                  mobile || tablet
                    ? styles.completeActivitiesMobile
                    : styles.completeActivities
                }
              >
                {values?.history?.length > 0 && (
                  <div
                    onClick={() => {
                      tracker.trackGoogleAnalyticsEvent(
                        'COMPLETE_ACTIVITIES',
                        'COMPLETE_ACTIVITIES',
                        trackerData,
                      );
                      setOpenApp(true);
                    }}
                  >
                    <span
                      style={{
                        display: 'block',
                        marginTop: mobile || tablet ? '4%' : '5%',
                        fontSize: 14,
                      }}
                    >
                      {noOfActivities && noOfActivities.length > 0 ? `Complete${' '} ` : `All activities${' '}`}
                      <span style={{ color: '#F48120', fontWeight: 'bold' }}>
                        {noOfActivities && noOfActivities.length > 0 ? noOfActivities.length : `are${' '}`}
                      </span>{' '}
                      {noOfActivities && noOfActivities.length > 0 ? 'Activities' : 'completed' }
                      <img
                        style={
                          mobile || tablet
                            ? styles.arrowIconMobile
                            : styles.arrowIcon
                        }
                        src={VectorOrange}
                        alt='orange'
                      />
                    </span>
                  </div>
                )}
                {(values?.history?.length <= 0 || !values?.history) && (
                  <Link
                    to='/events'
                    onClick={() => {
                      tracker.trackGoogleAnalyticsEvent(
                        'DISCOVER_NEW_EVENTS',
                        'DISCOVER_NEW_EVENTS',
                        trackerData,
                      );
                    }}
                  >
                    <span
                      style={{
                        display: 'block',
                        // marginTop: mobile || tablet ? '1%' : '5%',
                        whiteSpace: 'nowrap',
                        fontSize: 14,
                      }}
                    >
                      Discover New Events{' '}
                      <img
                        style={
                          mobile || tablet
                            ? styles.arrowIconMobile
                            : styles.arrowIcon
                        }
                        src={VectorOrange}
                        alt='orange'
                      />
                    </span>
                  </Link>
                )}
              </div>
            </ListItemText>
          </ListItem>
          <div
            className={className.card_list_scroll}
            style={{
              height: window.innerHeight * 0.6,
              overflowX: 'auto',
            }}
            onScroll={onScroll}
            ref={listInnerRef}
          >
            {renderList()}
          </div>
        </div>
      ) : (
        renderList()
      )}
    </>
  );
};
CredList.propTypes = {
  values: PropTypes.any.isRequired,
  setShowmore: PropTypes.func,
  showMore: PropTypes.bool,
  pageNo: PropTypes.number,
  fetchNewRecords: PropTypes.func,
  trackerData: PropTypes.object,
  noOfActivities: PropTypes.object,
  showAll: PropTypes.bool,
};

export default CredList;
